import { SlideFade } from '@chakra-ui/react';
import React from 'react';
import { SlideArgs } from './Slide.types';

export const SlideWrap = ({ children, isOpen }: SlideArgs) => {
  return (
    <SlideFade offsetY="20px" in={isOpen}>
      {children}
    </SlideFade>
  );
};
